import { createAppRequest } from '@/services/request';

const request = createAppRequest();

export interface IicPage<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

export type IicQuery = Record<string, string | number | boolean | undefined>;
export type IicRecord = Record<string, any> & {
  id?: number | string;
  uuid: string;
  version?: number;
  createdAt: string;
  updatedAt: string;
};

export function listIic<T extends IicRecord = IicRecord>(resource: string, params: IicQuery = {}) {
  return request<IicPage<T>>(`/bff/iic/${resource}`, { method: 'GET', params });
}

export function getIic<T extends IicRecord = IicRecord>(resource: string, uuid: string) {
  return request<T>(`/bff/iic/${resource}/${uuid}`, { method: 'GET' });
}

export function createIic<T extends IicRecord = IicRecord>(resource: string, data: Record<string, unknown>) {
  return request<T>(`/bff/iic/${resource}`, { method: 'POST', data });
}

export function updateIic<T extends IicRecord = IicRecord>(resource: string, uuid: string, data: Record<string, unknown>) {
  return request<T>(`/bff/iic/${resource}/${uuid}`, { method: 'PATCH', data });
}

export function deleteIic(resource: string, uuid: string) {
  return request<{ success: boolean }>(`/bff/iic/${resource}/${uuid}`, { method: 'DELETE' });
}

export function runIicCommand<T = IicRecord>(
  path: string,
  data: Record<string, unknown>,
  idempotencyKey: string = crypto.randomUUID(),
) {
  return request<T>(`/bff/iic/${path}`, {
    method: 'POST',
    data,
    headers: { 'Idempotency-Key': idempotencyKey },
  });
}

export function getIicWorkbench() {
  return request<Record<string, any>>('/bff/iic/dashboard/workbench', { method: 'GET' });
}

export function getIicAnalytics() {
  return request<Record<string, any>>('/bff/iic/dashboard/analytics', { method: 'GET' });
}
